const size = {
  mobileXS: '280px',
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  mobileXL: '550px',
  tablet: '768px',
  tabletXL: '975px',
  laptopS: '991px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
};

const DEVICES = {
  mobileXS: `(max-width: ${size.mobileXS})`,
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  mobile: `(min-width:${size.mobileS}) and (max-width:${size.mobileL})`,
  mobileXL: `(max-width:${size.mobileXL})`,
  tab: `(max-width:${size.tablet})`,
  mobileToTabletXL: `(max-width:${size.tabletXL})`,
  tabletSToTabletXL: `(min-width: ${size.tablet}) and (max-width: ${size.tabletXL})`,
  tablet: `(min-width: ${size.tablet}) and (max-width: ${size.laptop})`,
  laptopS: `(max-width: ${size.laptopS})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
  tabletXL: `(min-width: ${size.tabletXL})`
};

export const DEVICE_SIZE_NUMERIC = {
  mobileXS: 280,
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  mobileXL: 550,
  tablet: 768,
  tabletXL: 975,
  laptopS: 991,
  laptop: 1024,
  laptopL: 1440,
  desktop: 2560
};

export default DEVICES;
